import script from "./AgentStyles.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentStyles.vue?vue&type=script&setup=true&lang=js"

import "./AgentStyles.vue?vue&type=style&index=0&id=27b054e0&lang=css"

const __exports__ = script;

export default __exports__